import {GraphQLClient} from 'graphql-request';
import {MAGENTO_API_HOST} from '../../constants';

const MAGENTO_GRAPHQL_ENDPONT = `${MAGENTO_API_HOST}/graphql`;

const magentoGraphQLClient = new GraphQLClient(MAGENTO_GRAPHQL_ENDPONT, {
  headers: {
    'tkww-application': 'fe-member-shopping',
  },
});

export default magentoGraphQLClient;
